import { endpoint } from 'services/endpoint';
import { httpPay } from 'services/http';
import { TTransactionsApi } from './types';

export const transactions: TTransactionsApi = {
	getTransactions: (params) =>
		httpPay
			.get(endpoint.transactions.GET_TRANSACTIONS, { params })
			.then((response) => response.data),
};
